module.exports = __webpack_public_path__ + "static/media/ipc.df77b36a.png";